// extracted by mini-css-extract-plugin
export default {"activity_logs":"ActivityLogs_activity_logs__Td+RX","user_email_template":"ActivityLogs_user_email_template__v511p","export_calendar":"ActivityLogs_export_calendar__iuM7Q"};